export const USER_SOURCE_LABELS = {
    "MANUAL": "Manual",
    "STATIC": "Static",
    "AD_SYNC": "Microsoft Entra Sync",
    "GOOGLE_SYNC": "Google Workspace Sync"
};

export function resolveUserSourceLabel(userSource) {
    return USER_SOURCE_LABELS[userSource] || userSource || "Manual";
}
